import Datapoint from 'owa-service/lib/contract/Datapoint';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';
import { getUserCulture, getUserTimeZone } from 'owa-session-store';

export interface CaptureFeedbackDatapointProps {
    keys: string[];
    values: string[];
}

export function captureFeedbackDatapoint(props: CaptureFeedbackDatapointProps): Promise<boolean> {
    let sessionInfoLogDatapoint: Datapoint = {
        Id: 'SessionInfo',
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: ['clg', 'tz'],
        Values: [getUserCulture(), getUserTimeZone()],
    };

    // This is to make sure that timezone and clientlanguage is being logged
    // for each feedback.
    logDatapointOperation({ datapoints: [sessionInfoLogDatapoint] });

    let feedbackLogDatapoint: Datapoint = {
        Id: 'CaptureFeedback',
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: props.keys,
        Values: props.values,
    };

    return logDatapointOperation({ datapoints: [feedbackLogDatapoint] });
}
